{
  "personal-data-form": {
    "text": {
      "birthday": "Geburtstag",
      "name": "Name",
      "surname": "Nachname"
    }
  }
}
